export const DEFAULT_SCORE_WEIGHTS = {
  technicalSkills: 30,
  projectExperience: 25,
  industryBackground: 15,
  softSkills: 10,
  education: 10,
  careerProgression: 10
}

// 岗位类型关键词列表
const CONTENT_KEYWORDS = [
  "内容",
  "文案",
  "短视频",
  "小红书",
  "抖音",
  "创意",
  "热点",
  "梗",
  "脚本",
  "运营",
  "新媒体",
  "自媒体",
  "社交媒体",
  "爆款",
  "策划",
  "编辑",
  "写作",
  "传播",
  "互动",
  "粉丝",
  "账号",
  "矩阵",
];

const TECH_KEYWORDS = [
  "技术",
  "开发",
  "编程",
  "算法",
  "架构",
  "后端",
  "前端",
  "全栈",
  "数据",
  "AI",
  "机器学习",
  "深度学习",
  "系统",
  "软件",
  "硬件",
  "测试",
  "运维",
  "安全",
  "网络",
  "数据库",
  "云计算",
  "区块链",
];

const MANAGEMENT_KEYWORDS = [
  "管理",
  "领导",
  "团队",
  "战略",
  "规划",
  "决策",
  "协调",
  "沟通",
  "组织",
  "执行",
  "监督",
  "评估",
  "优化",
  "变革",
  "创新",
  "风险",
  "资源",
  "预算",
  "绩效",
  "文化",
  "愿景",
  "使命",
  "价值观",
];

export const generateWeights = (vacancy) => {
  const weights = {
    technicalSkills: 30,
    projectExperience: 25,
    industryBackground: 15,
    softSkills: 10,
    education: 10,
    careerProgression: 10,
  };

  const text = [
    vacancy.title,
    ...(vacancy.required_skills || []),
    ...(vacancy.preferred_skills || []),
    ...(vacancy.responsibilities || []),
    ...(vacancy.bonus_skills || []),
    ...(vacancy.hidden_requirements || []),
    ...(vacancy.years_experience || []),
    vacancy.education_level,
  ].filter(Boolean).join(" ");

  const isContentRole = CONTENT_KEYWORDS.some((kw) => text.includes(kw));
  const isTechRole = TECH_KEYWORDS.some((kw) => text.includes(kw));
  const isManagementRole = MANAGEMENT_KEYWORDS.some((kw) => text.includes(kw));

  if (isContentRole) {
    // 内容型岗位权重模板
    weights.technicalSkills = 5; // 技术技能极低
    weights.projectExperience = 30;
    weights.industryBackground = 15;
    weights.softSkills = 30; // 软技能极高
    weights.education = 10;
    weights.careerProgression = 10;
  } else if (isTechRole) {
    // 技术型岗位权重模板
    weights.technicalSkills = 40;
    weights.projectExperience = 30;
    weights.industryBackground = 10;
    weights.softSkills = 10;
    weights.education = 5;
    weights.careerProgression = 5;
  } else if (isManagementRole) {
    // 管理型岗位权重模板
    weights.technicalSkills = 10;
    weights.projectExperience = 20;
    weights.industryBackground = 10;
    weights.softSkills = 40;
    weights.education = 10;
    weights.careerProgression = 10;
  }

  // 根据职位描述中的关键词进一步微调权重（保留原有逻辑）
  if (vacancy.required_skills?.length > 0) {
    weights.technicalSkills = Math.min(
      40,
      weights.technicalSkills + vacancy.required_skills.length * 2,
    );
  }
  if (vacancy.responsibilities?.length > 0) {
    weights.projectExperience = Math.min(
      35,
      weights.projectExperience + vacancy.responsibilities.length * 2,
    );
  }
  if (vacancy.education_level) {
    weights.education = 15;
  }

  // 归一化权重，确保总和为100%
  const total = Object.values(weights).reduce((sum, w) => sum + w, 0);
  const keys = Object.keys(weights);
  const normalized = {};
  let sum = 0;
  keys.forEach((key, idx) => {
    if (idx === keys.length - 1) {
      normalized[key] = 100 - sum;
    } else {
      normalized[key] = Math.floor((weights[key] * 100) / total);
      sum += normalized[key];
    }
  });
  return normalized;
};
